module.exports = __webpack_public_path__ + "media/images/mail/all-item-btn-3ce403b0b2121e32ea2f54e3de8ccd9d.png";